import PropTypes from 'prop-types';

const GridLayout = ({
    headers,
    content,
}) => {
    return (
        <div className="grid-layout">
            <table width="100%">
                <thead>
                    <tr>
                        {headers?.map(({ label }, index) => (
                            <th key={index} className="property-label">{label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                {content?.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                        {headers?.map(({ key }, colIndex) => (
                            <td key={colIndex}>{row[key] || '-'}</td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

GridLayout.propTypes = {
    headers: PropTypes.array,
    content: PropTypes.array,
};

export default GridLayout;